import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useLookup } from "../../utils/useLookup";

const CommonFixationReport = () => {
  const { suppliers: shippers } = useLookup();
  const [fixationOption, setFixationOption] = useState("all");
  const [shipperId, setShipperId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rows, setRows] = useState([]);
  const [generated, setGenerated] = useState(false);





  const handleGenerate = async () => {
    try {
      const body = { fixationOption };
      if (shipperId) body.shipperId = Number(shipperId);
      if (fromDate)  body.fromDate  = fromDate;
      if (toDate)    body.toDate    = toDate;
      const res = await axios.post("/newdeal/report/common-fixation", body);
      setRows(res.data);
      setGenerated(true);
    } catch { alert("Failed to generate report."); }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Fixation</span>
        </div>
        <div className="card-body">
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Select Fixation Option</label>
              <div>
                {[["all", "All Fixation"], ["ongoing", "Ongoing Deal Fixation"], ["unfixed", "Unfixed"], ["fixed", "Fixed"]].map(([value, label]) => (
                  <div className="form-check" key={value}>
                    <input id={`fixation-${value}`} name="fixationOption" className="form-check-input" type="radio" value={value} checked={fixationOption === value} onChange={() => setFixationOption(value)} />
                    <label htmlFor={`fixation-${value}`} className="form-check-label">{label}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Select Supplier</label>
              <select className="form-select form-select-sm" value={shipperId} onChange={e => setShipperId(e.target.value)}>
                <option value="">All Supplier</option>
                {shippers.map(s => <option key={s.ShipperID} value={s.ShipperID}>{s.ShipperName}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">From Date</label>
              <input type="date" className="form-control form-control-sm" value={fromDate} onChange={e => setFromDate(e.target.value)} />
            </div>
            <div className="col-md-2">
              <label className="form-label">To Date</label>
              <input type="date" className="form-control form-control-sm" value={toDate} onChange={e => setToDate(e.target.value)} />
            </div>
            <div className="col-md-2">
              <button className="btn btn-success btn-sm" onClick={handleGenerate}>Generate Report</button>
            </div>
          </div>

          {generated && (
            <>
              <div className="mb-2 text-muted" style={{ fontSize: "13px" }}>Total Records: {rows.length}</div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-hover table-sm" style={{ fontSize: "13px" }}>
                  <thead className="table-success">
                    <tr>
                      <th>Deal ID</th><th>Container No</th><th>Weight</th><th>GC No</th>
                      <th>Rate Fixed LME</th><th>Final Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0
                      ? <tr><td colSpan={6} className="text-center text-muted py-3">No records found.</td></tr>
                      : rows.map((r, i) => (
                        <tr key={i}>
                          <td>{r.DealNo || r.DealID}</td><td>{r.ContainerNo || "-"}</td>
                          <td>{r.Weight ?? "-"}</td><td>{r.GCNo ?? "-"}</td>
                          <td>{r.RateFixedLME ?? "-"}</td><td>{r.FinalPrice ?? "-"}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonFixationReport;
